module.exports = __webpack_public_path__ + "img/2.34a10255.jpg";